import React, { useState, useEffect, useMemo } from "react";
import { useApiFetch } from "../utils/apiFetch";

function InputSelectEstados({
    idEstado,
    setIdEstado,
    estadoActualText,
    idEntidad,
    label = "Estado",
    readOnly = false,
    apiUrl,
    logout,
    mostrar // <-- nueva prop opcional
}) {
    const apiFetch = useApiFetch();
    const url = apiUrl || "consultar_estados.php";
    const [estados, setEstados] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const cargarEstados = async () => {
            setLoading(true);
            try {
                const data = await apiFetch(url, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" }
                }, logout);

                if (Array.isArray(data)) {
                    setEstados(data);
                    setError("");
                } else if (data.estados && Array.isArray(data.estados)) {
                    setEstados(data.estados);
                    setError("");
                } else {
                    setError(data.message || "❌ No se pudieron cargar los estados.");
                }
            } catch {
                setError("❌ Error de conexión al cargar estados.");
            } finally {
                setLoading(false);
            }
        };

        cargarEstados();
    }, [url, logout]);

    // Filtrar estados por entidad y excluir eliminados SOLO si mostrar !== "todos"
    const estadosFiltrados = useMemo(() => {
        return estados.filter(e => {
            const mismaEntidad = Number(e.id_entidad) === Number(idEntidad);
            if (mostrar === "todos") {
                return mismaEntidad; // no excluye nada
            }
            return (
                mismaEntidad &&
                e.estado.toUpperCase() !== "ELIMINADO" &&
                e.estado.toUpperCase() !== "ELIMINADA"
            );
        });
    }, [estados, idEntidad, mostrar]);

    const opciones = useMemo(() => {
        const lista = [...estadosFiltrados];
        if (idEstado) {
            const existe = lista.some(e => Number(e.id_estado) === Number(idEstado));
            if (!existe && estadoActualText) {
                lista.unshift({
                    id_estado: idEstado,
                    estado: estadoActualText,
                    id_entidad: idEntidad
                });
            }
        }
        return lista;
    }, [estadosFiltrados, idEstado, estadoActualText, idEntidad]);

    return (
        <div className="form-group">
            <label>{label}</label>
            <select
                className="input"
                value={idEstado || ""}
                onChange={(e) => setIdEstado(Number(e.target.value))}
                disabled={readOnly || loading}
            >
                <option value="" disabled>
                    Seleccione un estado
                </option>
                {opciones.map((estado) => (
                    <option key={estado.id_estado} value={estado.id_estado}>
                        {estado.estado}
                    </option>
                ))}
            </select>

            {loading && <div className="loading">Cargando estados...</div>}
            {error && <div className="error">{error}</div>}
        </div>
    );
}

export default InputSelectEstados;
